<template>
  <div class="row m-1">
    <b-card :title="email" :sub-title="created_at" class="w-100">
      <b-card-text>
        {{ content }}
      </b-card-text>
      <hr />
      <b-card-text class="text-right">
        Likes: <i class="fas fa-arrow-alt-circle-up"></i> {{ likes }} | Deslikes
        <i class="fas fa-arrow-alt-circle-down"></i> {{ dislikes }}
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    created_at: {
      type: String | Date,
      required: true,
    },
    likes: {
      type: Number,
      required: true,
    },
    dislikes: {
      type: Number,
      required: true,
    },
  },
};
</script>
